export const getCOVIDIntentUrl = (alias: string) => `/covid-19/ask/${alias}/`;

export const getCountryUrl = (countryAlias: string) =>
  getCOVIDIntentUrl(`what-is-the-covid-19-situation-in-${countryAlias}`);

export const getCountryWithResUrl = (countryAlias: string) =>
  getCOVIDIntentUrl(
    `what-is-the-government-response-timeline-for-${countryAlias}`
  );
